import React from 'react';
import { Badge, BadgeProps } from 'pounceV2';
import { useTheme } from '@mui/material';

const FlatBadgeV3: React.FC<Pick<BadgeProps, 'color' | 'children'>> = props => {
  const {
    palette: { typographyTokens },
  } = useTheme();

  return (
    <Badge
      {...props}
      size="small"
      variant="info-subtle"
      borderStyle="rectangle"
      sx={{ fontSize: typographyTokens.fontSizes.xxs }}
      emphasized
    />
  );
};

export default FlatBadgeV3;
